module.exports = __webpack_public_path__ + "img/good_food.b283e295.jpg";